// extracted by mini-css-extract-plugin
export default {"actions":"apiReport_actions__vZovo","container":"apiReport_container__2BOTd","title":"apiReport_title__lntDK"};